import { useEffect, useRef, useState } from "react";
import { CaretDown, Check, Sparkle } from "@phosphor-icons/react";
import { MODEL_META, modelLabel } from "../lib/api";

const IMAGE_MODELS = ["nano-banana", "gpt-image-1"];

export const ModelPicker = ({ providers, selection, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const pick = (provider, model) => {
    onChange({ provider, model });
    setOpen(false);
  };

  const groups = [
    ...Object.keys(providers).map((p) => ({ provider: p, meta: MODEL_META[p], models: providers[p] })),
    { provider: "image", meta: MODEL_META.image, models: IMAGE_MODELS },
  ];

  const currentMeta = MODEL_META[selection.provider] || MODEL_META.openai;

  return (
    <div className="relative" ref={ref}>
      <button data-testid="model-picker-button" onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-[13px] font-medium text-[var(--text-2)] hover:text-[var(--text)] hover:bg-[var(--hover)] px-2.5 py-1.5 rounded-lg transition-colors duration-300">
        {selection.provider === "image"
          ? <Sparkle size={13} weight="fill" style={{ color: currentMeta.color }} />
          : <span className="w-2 h-2 rounded-full" style={{ background: currentMeta.color }} />}
        {modelLabel(selection.model)}
        <CaretDown size={11} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div data-testid="model-picker-menu"
          className="absolute bottom-full left-0 mb-2 w-64 max-w-[calc(100vw-4.5rem)] max-h-96 overflow-y-auto bg-[var(--surface)] border border-[var(--border-strong)] rounded-2xl py-2 z-50 scale-in"
          style={{ boxShadow: "var(--shadow)" }}>
          {groups.map((g) => (
            <div key={g.provider}>
              <p className="px-4 pt-2.5 pb-1 text-[10px] font-semibold uppercase tracking-wider" style={{ color: g.meta.color }}>
                {g.provider === "image" ? "Image Generation" : g.meta.label}
              </p>
              {g.models.map((m) => {
                const active = selection.provider === g.provider && selection.model === m;
                return (
                  <button key={m} data-testid={`model-option-${m}`} onClick={() => pick(g.provider, m)}
                    className={`w-full flex items-center justify-between px-4 py-2 text-[13px] transition-colors duration-200 hover:bg-[var(--hover)] ${active ? "text-[var(--text)] font-medium" : "text-[var(--text-2)]"}`}>
                    {modelLabel(m)}
                    {active && <Check size={14} style={{ color: g.meta.color }} weight="bold" />}
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
